import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DailyCollectionSummeryReport } from './Pages';

export const DailyCollectionSummeryReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={DailyCollectionSummeryReport} />
    </Fragment>
)